<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>
<div class="content">
  <div class="scroll-wrapper ui basic segment" [ngClass]="{ loading: pending }">
    <div *ngIf="success || error" tamsyMargin marginY="10px">
      <esl-message-toast [(message)]="success" [messageType]="'success'"></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>
    <!--Laboratory form  -->
    <div class="ui form" [formGroup]="userForm">
      <ng-template [ngIf]="screen !== 'value'">
        <p>Please confirm your password to change your {{modal.context.isUsername ? "Username" : "Email"}}</p>
        <div class="field" [ngClass]="displayFieldCss('password')">
          <label class="required">Password</label>
          <input formControlName="password" type="password" placeholder="Enter password" />
          <app-field-error-display [displayError]="isFieldValid('password')" errorMsg="Please enter password">
          </app-field-error-display>
        </div>
      </ng-template>
      <ng-template [ngIf]="modal.context.isUsername">
        <div *ngIf="screen == 'value'" class="field" [ngClass]="displayFieldCss('usernameOrEmail')">
          <label class="required">Username</label>
          <input formControlName="usernameOrEmail" type="text" placeholder="Enter username" />
          <app-field-error-display [displayError]="isFieldValid('usernameOrEmail')" errorMsg="Please enter username">
          </app-field-error-display>
        </div>
      </ng-template>
      <ng-template [ngIf]="!modal.context.isUsername">
        <div *ngIf="screen == 'value'" class="field" [ngClass]="displayFieldCss('usernameOrEmail')">
          <label class="required">Email</label>
          <input formControlName="usernameOrEmail" type="text" placeholder="Enter email" />
          <app-field-error-display [displayError]="isFieldValid('usernameOrEmail')" errorMsg="Please enter email">
          </app-field-error-display>
        </div>
      </ng-template>
    </div>
  </div>
</div>

<div class="actions">
  <button class="ui basic primary button" (click)="modal.deny(undefined)">
    Cancel
  </button>
  <button class="ui primary button" *ngIf="screen !== 'value'" [ngClass]="{ yellow: pending }"
    [disabled]="!userForm.get('password').valid || pending" (click)="continue()" autofocus>
    Continue
  </button>
  <button class="ui primary button" *ngIf="screen == 'value'" [ngClass]="{ yellow: pending }"
    [disabled]="!userForm.get('usernameOrEmail').valid || pending" (click)="submit()" autofocus>
    Done
  </button>
</div>
